<template>
  <div>
    <b-nav tabs>
      <b-nav-item :to="{ name: 'TheNotificationDetail' }"
        >Send Notification</b-nav-item
      >
      <b-nav-item :to="{ name: 'WithdrawalsList' }"
        >Withdrawal Requests</b-nav-item
      >
      <b-nav-item :to="{ name: 'DealsList' }">Deals</b-nav-item>
      <b-nav-item :to="{ name: 'Advertisements' }">Advertisements</b-nav-item>
    </b-nav>

    <!-- nested router -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TheHome',
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    }
  }
};
</script>
